import styled from 'styled-components';

export default styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: left;
  
  .mapboxgl-map {
    text-align: left;
  }
`;
